module.exports = __webpack_public_path__ + "img/noimage-news.39942e34.jpg";